export default __webpack_public_path__ + "static/media/plan_subscription_image.605d11ad.svg";